import React from 'react';
import { Link } from 'react-router-dom';
import flower from '../../../images/icon/flower-icon.svg';
import brand1 from '../../../images/brand/logo01.png';
import brand2 from '../../../images/brand/logo02.png';
import brand3 from '../../../images/brand/logo03.png';
import brand4 from '../../../images/brand/logo04.png';
import brand5 from '../../../images/brand/logo05.png';
import brand6 from '../../../images/brand/logo06.png';
import brand7 from '../../../images/brand/logo07.png';
import brand8 from '../../../images/brand/logo08.png';

const BrandSection = ({data}) => {

  return (
    <section className="brand pt-135 pb-140" style={{ backgroundColor: "#111112" }}>
      <div className="container">
        <div className="xb-brand-title mb-65">
          <img src={flower} alt="" />
          <span className='fs-4'>{data.title}</span>
          <img src={flower} alt="" />
        </div>
        <div className="xb-brand-wrap">
          <div className="xb-brand-item">
            <div className="xb-brand-single xb-brand-hover">
              <a href={data.files[0].description}>
                <img src={data.files_main_path + data.files[0].file_name} alt={data.files[0].title} />
              </a>
              {/* <Link to="/home-2" className="xb-overlay"></Link> */}
            </div>
            <div className="xb-brand-single xb-brand-hover">
            <a href={data.files[1].description}>
                <img src={data.files_main_path + data.files[1].file_name} alt={data.files[1].title} />
              </a>
              {/* <Link to="/home-2" className="xb-overlay"></Link> */}
            </div>
          </div>
          <div className="xb-brand-item xb-brand-item--big xb-brand-hover">
          <a href={data.files[2].description}>
              <img src={data.files_main_path + data.files[2].file_name} alt={data.files[2].title} />
            </a>
            {/* <Link to="/home-2" className="xb-overlay"></Link> */}
          </div>
          <div className="xb-brand-item">
            <div className="xb-brand-single xb-brand-hover">
            <a href={data.files[3].description}>
                <img src={data.files_main_path + data.files[3].file_name} alt={data.files[3].title} />
              </a>
              {/* <Link to="/home-2" className="xb-overlay"></Link> */}
            </div>
            <div className="xb-brand-single xb-brand-hover">
            <a href={data.files[4].description}>
                <img src={data.files_main_path + data.files[4].file_name} alt={data.files[4].title} />
            </a>
                {/* <Link to="/home-2" className="xb-overlay"></Link> */}
            </div>
          </div>
          <div className="xb-brand-item xb-brand-item--big xb-brand-hover">
          <a href={data.files[5].description}>
              <img src={data.files_main_path + data.files[5].file_name} alt={data.files[5].title} />
            </a>
            {/* <Link to="/home-2" className="xb-overlay"></Link> */}
          </div>
          <div className="xb-brand-item">
            <div className="xb-brand-single xb-brand-hover">
            <a href={data.files[6].description}>
                <img src={data.files_main_path + data.files[6].file_name} alt={data.files[6].title} />
              </a>
              {/* <Link to="/home-2" className="xb-overlay"></Link> */}
            </div>
            <div className="xb-brand-single xb-brand-hover">
            <a href={data.files[7].description}>
                <img src={data.files_main_path + data.files[7].file_name} alt={data.files[7].title} />
              </a>
                {/* <Link to="/home-2" className="xb-overlay"></Link> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrandSection;
